"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaFieldFactoryFromJS = exports.MetaFieldFactory = void 0;
const immutable_1 = require("immutable");
exports.MetaFieldFactory = (0, immutable_1.Record)({
    childs: (0, immutable_1.List)(),
    displayName: '',
    name: '',
    valueType: 0 /* EParameterValueTypes.Unknown */
});
const MetaFieldFactoryFromJS = function (data) {
    return (0, exports.MetaFieldFactory)({
        childs: (0, immutable_1.List)(data.childs ? data.childs.map(i => (0, exports.MetaFieldFactoryFromJS)(i)) : []),
        displayName: data.displayName,
        name: data.name,
        valueType: data.valueType
    });
};
exports.MetaFieldFactoryFromJS = MetaFieldFactoryFromJS;
//# sourceMappingURL=IMetaField.js.map